import React from 'react'
import BaseComponent from './BaseComponent'
import { NavLink } from 'react-router-dom'
import Map from './Map'
import Footer from './Footer'
import _ from 'lodash'
import $ from 'jquery'
import Parsley from 'parsleyjs'
import Modal from './Modal'

export default class ContactPage extends BaseComponent {

  constructor(props) {
    super(props)
    this.state = { email: "", name: "", phone: "", message: "", error: false, popup: false }
    this._bind('handleInputChange', 'sendForm', 'submitForm', 'showError', 'showPopup', 'closeError', 'closePopup')
    Parsley.addMessages('pl', {
      defaultMessage: "Wartość wygląda na nieprawidłową",
      type: {
        email:        "Wpisz poprawny adres e-mail.",
        url:          "Wpisz poprawny adres URL.",
        number:       "Wpisz poprawną liczbę.",
        integer:      "Dozwolone są jedynie liczby całkowite.",
        digits:       "Dozwolone są jedynie cyfry.",
        alphanum:     "Dozwolone są jedynie znaki alfanumeryczne."
      },
      notblank:       "Pole nie może być puste.",
      required:       "Pole jest wymagane.",
      pattern:        "Pole zawiera nieprawidłową wartość.",
      min:            "Wartość nie może być mniejsza od %s.",
      max:            "Wartość nie może być większa od %s.",
      range:          "Wartość powinna zaweriać się pomiędzy %s a %s.",
      minlength:      "Minimalna ilość znaków wynosi %s.",
      maxlength:      "Maksymalna ilość znaków wynosi %s.",
      length:         "Ilość znaków wynosi od %s do %s.",
      mincheck:       "Wybierz minimalnie %s opcji.",
      maxcheck:       "Wybierz maksymalnie %s opcji.",
      check:          "Wybierz od %s do %s opcji.",
      equalto:        "Wartości nie są identyczne."
    });

    Parsley.setLocale('pl');
  }

  showPopup() {
    this.setState({ popup: true })
  }

  showError() {
    this.setState({ error: true })
  }

  closePopup() {
    this.setState({ email: "", name: "", phone: "", message: "", error: false, popup: false })
  }

  closeError() {
    this.setState({ email: "", name: "", phone: "", message: "", error: false, popup: false })
  }

  handleInputChange(event) {
      const target = event.target
      let value = target.type === 'checkbox' ? target.checked : target.value
      let name = target.name

      this.setState({
        [name]: value
      })
  }

  sendForm(e) {
    e.preventDefault()

    if($('.form').parsley().validate()) {
      this.submitForm()
    }
  }

  submitForm() {

    let data = {
      title: "Formularz WWW - Formularz kontaktowy",
      name: this.state.name,
      phone: this.state.phone,
      email: this.state.email,
      message: this.state.message
    }

    fetch('/mailer/index.php', {
        method: "POST", 
        headers: {
            "Content-Type": "application/json; charset=utf-8"
        },
        body: JSON.stringify(data),
    })
    .then((response, status) => {
      return response.json()
    })
    .then((result) => {
      if (result.result === 0) {
        this.showError()
      } else {
        this.showPopup()
      }
    },(error) => {
      this.showError()
      console.log(error)
    })
  }

  render() {
  	const page = _.filter(this.props.data.pages, { template: "contact" })[0]

    const Popup = (
      <div className="popup-inner">
        <div className="close" onClick={ this.closePopup }></div>
        <h1>Dziękujemy</h1>
        <h4>Za zainteresowanie naszą ofertą</h4>
        <p>Skontaktujemy się z Państwem najszybciej jak to możliwe.</p>
        <button className="btn" onClick={ this.closePopup }><span>Zamknij</span><div className="close-modal"></div></button>
      </div>
    )

    const ErrorPopup = (
      <div className="popup-inner">
        <div className="close" onClick={ this.closeError }></div>
        <h1>Wystąpił błąd!</h1>
        <p>Prosimy spróbować ponownie.</p>
        <button className="btn" onClick={ this.closeError }><span>Zamknij</span><div className="close-modal"></div></button>
      </div>
    )

    return (
      <section className="contact">
      	<ul className="breadcrumbs">
      		<div className="container-big">
	      		<li><NavLink to="/">Strona główna</NavLink></li>
	      		<li><NavLink to="/kontakt">Kontakt</NavLink></li>
      		</div>
      		<div className="bottom"></div>
      	</ul>
      	<div className="container">
      		<h1 dangerouslySetInnerHTML={{ __html: this.addColor(page.additional_fields.pageTitle) }}></h1>
      		<div className="contact-inner">
      			<div className="contact-data" dangerouslySetInnerHTML={{ __html: page.additional_fields.content }}></div>
      			<div className="contact-form">
      			{ this.props.screen.width < 1020 ? <h3>Formularz kontaktowy</h3> : null}
      				<form className="form">
                <div className="inputs">
                  <div><input type="text" name="name" value={ this.state.name } onChange={ this.handleInputChange } placeholder="Imię i nazwisko" required/></div>
                  <div><input type="email" name="email" value={ this.state.email } onChange={ this.handleInputChange } placeholder="Adres e-mail" required/></div>
                  <div><input type="text" name="phone" value={ this.state.phone } onChange={ this.handleInputChange } placeholder="Numer telefonu" required/></div>
                </div>
                <textarea name="message" value={ this.state.message } onChange={ this.handleInputChange } placeholder="Treść wiadomości" required></textarea>
                <button className="btn" onClick={ this.sendForm }>Wyślij</button>
              </form>
      			</div>
      		</div>
      	</div>
      	<Map/>
      	<Footer data={ this.props.data } settings={ this.props.data.settings }/>
        <Modal open={ this.state.popup } hidePopup={ this.closePopup }>{ Popup }</Modal>
        <Modal open={ this.state.error } hidePopup={ this.closeError }>{ ErrorPopup }</Modal>
      </section>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/components/ContactPage.js